import DocumentModule from "@/components/DocumentModule";

export default function Quotations() {
  return (
    <DocumentModule
      title="Quotations"
      subtitle="Estimates & professional quotations · convert to invoice with one click"
      endpoint="quotations"
      numberKey="quotation_number"
      dateKey="quotation_date"
      pageTestId="quotations-page"
      showConvert
    />
  );
}
